var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .check {\n      fill: none;\n      stroke: #22c55e;\n      stroke-width: 10;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n      stroke-dasharray: 120;\n      stroke-dashoffset: 120;\n      animation: draw-check 1.2s ease-in-out infinite;\n    }\n\n    @keyframes draw-check {\n      0% {\n        stroke-dashoffset: 120;\n        opacity: 0;\n      }\n      20% {\n        opacity: 1;\n      }\n      50% {\n        stroke-dashoffset: 0;\n        opacity: 1;\n      }\n      80% {\n        opacity: 1;\n      }\n      100% {\n        stroke-dashoffset: -120;\n        opacity: 0;\n      }\n    }\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "check",
    d: "M20 52 L42 72 L80 30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.060147dbbcfa1a87c4a40ef1ec575b7a.svg";
export { ForwardRef as ReactComponent };